module.exports = "/_next/static/images/cancel-be4a1d427a35914a6c57623913d0cd71.svg";